module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/chevron-disabled.a76cf210.svg";